import { SOCKET_CONNECT, SOCKET_DISCONNECT, MSA_JOIN_ROOM, MSA_EXIT_ROOM, ROOM_INFO_UPDATED, CALL, QUEUE_NEXT_CALLING, ROOM_PASSED_DONOR, ROOM_CREATED } from "../actions/webSocket";
import { Socket } from '../utils/webSocketService';
import { incomingMessage } from '../utils/webSocketMessage';
import { QUEUE_SOCKET } from "../actions/queueAction";
import { useSelector } from "react-redux";
import { store } from "@/web/components/state/store";

export const socketMiddleware = (socket) => (params) => {
    let isConnected = false;
    const socket = new Socket();
    let intervalId = null;

    const { dispatch, getState } = params;

    const checkConnection = () => isConnected;

    const reconnect = () => {
        setTimeout(() => {
            dispatch({ type: SOCKET_CONNECT });
        }, 1000);
    };

    return (next) => (action) => {
        const { type, userInfo } = action;
        const socketConnectReducer = store.getState().socketConnectReducer;

        if (userInfo && type === SOCKET_CONNECT) {
            socket.connect(process.env.REACT_APP_CALLING + `/call?id=${userInfo.siteId}`);
            isConnected = true; 
        }

        switch (type) {
            case SOCKET_CONNECT:
                socket.on('open', () => {
                    dispatch({ type: QUEUE_SOCKET.SOCKET_CONNECT_NEW, payload: true });
                    isConnected = true;
                });

                socket.on('message', (event) => {
                    let incomingVariable = JSON.parse(event.data);
                    let data = incomingMessage(incomingVariable);
                    let typeText = data.text;

                    if(typeText) {
                    }

                    switch (typeText) {
                        case MSA_JOIN_ROOM:
                            dispatch({ type: MSA_JOIN_ROOM, payload: data });
                            break;
                        case MSA_EXIT_ROOM:
                            dispatch({ type: MSA_EXIT_ROOM, payload: data });
                            break;
                        case ROOM_INFO_UPDATED:
                            dispatch({ type: ROOM_INFO_UPDATED, payload: data });
                            break;
                        case CALL:
                            dispatch({ type: CALL, payload: data });
                            break;
                        case QUEUE_NEXT_CALLING:
                            dispatch({ type: QUEUE_NEXT_CALLING, payload: data });
                            break;
                        case ROOM_PASSED_DONOR:
                            dispatch({ type: ROOM_PASSED_DONOR, payload: data });
                            break;
                        case ROOM_CREATED:
                            dispatch({ type: ROOM_CREATED, payload: data });
                            break;
                        default:
                            break;
                    }
                });

                socket.on('close', () => {
                    isConnected = false;
                    dispatch({ type: QUEUE_SOCKET.SOCKET_CONNECT_NEW, payload: false });
                    reconnect();
                    
                });
                break;

            case SOCKET_DISCONNECT:
                socket.close();
                isConnected = false; 
                clearInterval(intervalId);
                intervalId = null;
                dispatch({ type: QUEUE_SOCKET.SOCKET_CONNECT_NEW, payload: false });
                break;

            default:
                break;
        }

        return next(action);
    };
};

export const QueueUpdateReducer = (dispatch, getState, typeText, siteIds) => {
    let isConnected = false;
    const user = store.getState().userInfStateReducer;
    const userInfo = user && user.userInfo ? user.userInfo : null;

    if (userInfo) {
        let siteId = siteIds ? siteIds : userInfo.siteId;

        const socket = new Socket();
        socket.on('open', () => {
            isConnected = true; 
        });
        socket.connect(process.env.REACT_APP_CALLING + `/call?id=${siteId}`);
        store.dispatch({ type: SOCKET_CONNECT });

        socket.on('message', (event) => {
            let incomingVariable = JSON.parse(event.data);
            let data = incomingMessage(incomingVariable);
            let typeText = data.text;


        });

    }
};